.kg{font-family:inherit;}